
<section class="agpr-newOnlineBriefing">
    <ng-container *ngIf="isChoosingTemplate; else setupBriefing">
        <div class="agpr-newOnlineBriefing-heading">
            <h2 class="agpr-newOnlineBriefing-headingTitle">
                {{ 'Briefing.onlineBriefing.createOnlineBriefing' | localize }}
            </h2>
        </div>
        <div class="agpr-newOnlineBriefing-quickTemplatesContainer">
            @if (hasAgent) {
                <agpr-agent-banner
                    class="agpr-newOnlineBriefing-agentBanner"
                    [id]="'agpr_newOnlineBriefing'"
                    [headerTitle]="'Briefings.newBriefing.subHeading.naturalLanguage'"
                    [placeholder]="'Briefings.newBriefing.naturalLanguage.placeholder'"
                    [submitTooltip]="'Briefings.newBriefing.prcopilot.submitTooltip'"
                    [submitTooltipEmpty]="'Briefings.newBriefing.prcopilot.submitTooltipEmpty'"
                    [hasAgentDebug]="hasAgentDebug"
                    [(naturalLanguagePrompt)]="naturalLanguagePrompt"
                    [(taskDescription)]="taskDescription"
                    [(systemPrompt)]="systemPrompt"
                    [(topicSystemPrompt)]="topicSystemPrompt"
                    (submit)="onAgentBannerSubmit($event)"
                ></agpr-agent-banner>
            }
            <div class="agpr-newOnlineBriefing-tabsContainer">
                <agpr-tabs
                    class="agpr-newOnlineBriefing-tabs"
                    [selectedTabIndex]="selectedTabIndex"
                    (selectedTabIndexChange)="selectedTabIndex = $event;"
                >
                    <agpr-tab
                        [id]="'agpr_newOnlineBriefing_quickTemplates_tab'"
                        icon="fa-kit-duotone fa-agpr-template"
                        heading="Briefings.newBriefing.tab.quickTemplates"
                        class="agpr-newOnlineBriefing-tab"
                    >
                        <div class="agpr-newOnlineBriefing-quickTemplates">
                            <div
                                class="agpr-newOnlineBriefing-templateListContainer"
                            >
                                <agpr-template-card
                                    *ngFor="let template of onlineBriefingTemplates"
                                    [template]="template"
                                    (click)="selectTemplate(template)"
                                    (keydown)="selectTemplate(template)"
                                >
                                </agpr-template-card>
                            </div>
                        </div>
                    </agpr-tab>
                    <agpr-tab
                        [id]="'newOnlineBriefing_savedTemplates_tab'"
                        class="agpr-newOnlineBriefing-tab"
                        icon="fa-regular fa-duotone fa-floppy-disk"
                        heading="Briefings.createDialog.savedTemplate"
                    >
                        <div class="agpr-newOnlineBriefing-paddedContent">
                            <h3 class="agpr-newOnlineBriefing-subHeading">
                                {{ 'Briefings.createDialog.chooseTemplate' | localize }}
                            </h3>
                            <agpr-list-filter-select
                                [id]="'agpr_newOnlineBriefing_savedTemplates_filterSelectList'"
                                [list]="canvasTemplateListItems"
                                [vsMinBufferPx]="560"
                                [vsMaxBufferPx]="1050"
                                listAriaLabel="Briefings.newBriefing.savedTemplates.listArialLabel"
                                placeholder="Briefings.newBriefing.savedTemplates.helperText"
                                textInputAriaLabel="Briefings.newBriefing.savedTemplates.helperText"
                                [showActionButton]="true"
                                actionButtonTooltip="Briefings.newBriefing.savedTemplates.manageTemplates"
                                (actionButtonClicked)="openManageTemplateDialog()"
                                (itemSelected)="onCanvasTemplateSelect($event)"
                            ></agpr-list-filter-select>
                        </div>
                    </agpr-tab>
                    <agpr-tab
                        [id]="'newOnlineBriefing_pastBriefings_tab'"
                        class="agpr-newOnlineBriefing-tab"
                        icon="fa-solid fa-duotone fa-clock-rotate-left"
                        heading="Briefings.newBriefing.tab.pastBriefings"
                    >
                        <div class="agpr-newOnlineBriefing-paddedContent">
                            <h3 class="agpr-newOnlineBriefing-subHeading">
                                {{ 'Briefings.newBriefing.subHeading.pastBriefings' | localize }}
                            </h3>
                            <agpr-list-filter-select
                                [id]="'agpr_newOnlineBriefing_pastBriefings_filterSelectList'"
                                [list]="briefingListItems"
                                [vsMinBufferPx]="560"
                                [vsMaxBufferPx]="1050"
                                listAriaLabel="Briefings.newBriefing.pastBriefings.listArialLabel"
                                placeholder="Briefings.createDialog.pastBriefingSearchPlaceholder"
                                textInputAriaLabel="Briefings.createDialog.pastBriefingSearchPlaceholder"
                                (itemSelected)="onBriefingSelect($event)"
                            ></agpr-list-filter-select>
                        </div>
                    </agpr-tab>
                </agpr-tabs>
            </div>
        </div>
    </ng-container>
    <ng-template #setupBriefing>
        <div class="agpr-newOnlineBriefing-heading">
            <h2 class="agpr-newOnlineBriefing-headingTitle">
                {{ 'Briefing.onlineBriefing.setup' | localize }}
            </h2>
            <div class="agpr-newOnlineBriefing-headingDescription">
                <p class="agpr-newOnlineBriefing-descriptionText">
                    {{ ('Briefing.onlineBriefing.template.' + selectedTemplate) | localize }}
                </p>
                <p class="agpr-newOnlineBriefing-headingDescriptionRequired">
                    <span class="agpr-requiredAsterix"> * </span>
                    {{ 'Briefing.onlineBriefing.requiredField' | localize }}
                </p>
            </div>
        </div>

        <div class="agpr-newOnlineBriefing-main">
            <div class="agpr-newOnlineBriefing-mainLeft">
                <agpr-scroll-panel
                    #leftScrollPanel
                >
                    <div class="agpr-newOnlineBriefing-main-content">
                        <div>
                            <h2 id="type_label" class="agpr-newOnlineBriefing-main-content-heading">{{ 'Briefing.onlineBriefing.settings.type' | localize }}</h2>
                            <div class="agpr-newOnlineBriefing-type" role="radiogroup" aria-labelledby="type_label">
                                <div
                                    class="agpr-newOnlineBriefing-typeCard"
                                    [ngClass]="{'agpr-newOnlineBriefing-typeCard--selected': selectedSchedulingType === deliverySchedulingTypes.immediate}"
                                    (click)="schedulingTypeChanged(deliverySchedulingTypes.immediate)"
                                    role="radio"
                                    [attr.aria-checked]="selectedSchedulingType === deliverySchedulingTypes.immediate"
                                    tabindex="0"
                                    aria-labelledby="immediate_label"
                                >
                                    <div class="agpr-newOnlineBriefing-typeCard-firstRow">
                                        <span class="agpr-newOnlineBriefing-typeCard-icon fa-duotone fa-regular fa-file"></span>
                                        <div id="immediate_label" class="agpr-newOnlineBriefing-typeCard-title">
                                            {{ 'Briefing.onlineBriefing.settings.oneOff' | localize }}
                                        </div>
                                    </div>
                                    <div class="agpr-newOnlineBriefing-typeCard-description">
                                        {{ 'Briefing.onlineBriefing.settings.oneOff.tooltip' | localize }}
                                    </div>
                                </div>
                                <div
                                    class="agpr-newOnlineBriefing-typeCard"
                                    [ngClass]="{'agpr-newOnlineBriefing-typeCard--selected': selectedSchedulingType === deliverySchedulingTypes.recurring}"
                                    (click)="schedulingTypeChanged(deliverySchedulingTypes.recurring)"
                                    role="radio"
                                    [attr.aria-checked]="selectedSchedulingType === deliverySchedulingTypes.recurring"
                                    tabindex="0"
                                    aria-labelledby="recurring_label"
                                >
                                    <div class="agpr-newOnlineBriefing-typeCard-firstRow">
                                        <span class="agpr-newOnlineBriefing-typeCard-icon fa-duotone fa-regular fa-files"></span>
                                        <div id="recurring_label" class="agpr-newOnlineBriefing-typeCard-title">
                                            {{ 'Briefing.onlineBriefing.settings.recurring' | localize }}
                                        </div>
                                    </div>
                                    <div class="agpr-newOnlineBriefing-typeCard-description">
                                        {{ 'Briefing.onlineBriefing.settings.recurring.tooltip' | localize }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        @if (selectedTemplate === onlineBriefingTemplateEnum.ONLINE_BRIEFING_TEMPLATE_DEFAULT
                            || selectedTemplate === onlineBriefingTemplateEnum.ONLINE_BRIEFING_TEMPLATE_QUARTERLY
                            || selectedTemplate === onlineBriefingTemplateEnum.ONLINE_BRIEFING_TEMPLATE_MONTHLY
                        ) {
                            <h2 class="agpr-newOnlineBriefing-main-content-heading">
                                {{ 'Briefing.onlineBriefing.settings.brand' | localize }}
                            </h2>
                        }

                        @if (selectedTemplate === onlineBriefingTemplateEnum.ONLINE_BRIEFING_TEMPLATE_COMPETITOR) {
                            <h2 class="agpr-newOnlineBriefing-main-content-heading">
                                {{ 'Briefing.onlineBriefing.settings.competitor.representing' | localize}}
                            </h2>
                        }
                        <agpr-monitoring-brand-card
                            #brandCardTemp
                            [id]="'agpr_newOnlineBriefing_brandCard'"
                            [showLogoField]="true"
                            [dataSourceConfigs]="brandCardDataSourceConfigs"
                            [isGlobalDateRange]="true"
                            [quarterlyConfigs]="quarterlyConfigs"
                            [monthlyConfigs]="monthlyConfigs"
                            [(ngModel)]="brandCard"
                            (ngModelChange)="onBrandCardChanged()"
                            (brandSelected)="populateCompetitors()"
                        ></agpr-monitoring-brand-card>
                        @if (selectedTemplate === onlineBriefingTemplateEnum.ONLINE_BRIEFING_TEMPLATE_COMPETITOR) {
                            <h2 class="agpr-newOnlineBriefing-main-content-heading">
                                <span>{{ 'Briefing.onlineBriefing.settings.coverageSource' | localize }}</span>
                                <span class="agpr-requiredAsterix"> * </span>
                            </h2>
                            <div #brandCardDataSourceLeft>
                                <ng-container *ngTemplateOutlet="brandCardTemp.dataSourcePicker()"></ng-container>
                            </div>
                            <ng-container *ngTemplateOutlet="analysisFocusTemp"></ng-container>
                            <ng-container *ngTemplateOutlet="bannerStyle"></ng-container>
                        }
                    </div>
                </agpr-scroll-panel>
            </div>
            <div class="agpr-newOnlineBriefing-mainRight">
                @if (selectedTemplate === onlineBriefingTemplateEnum.ONLINE_BRIEFING_TEMPLATE_COMPETITOR) {
                    <div class="agpr-newOnlineBriefing-flexContainer">
                        <h2 id="type_label" class="agpr-newOnlineBriefing-main-content-heading">
                            {{ 'Briefing.onlineBriefing.settings.competitor.competitors' | localize}}
                        </h2>
                        <agpr-button
                            [id]="'newOnlineBriefing_newCompetitor'"
                            icon="fa-regular fa-duotone fa-square-plus"
                            [tooltip]="competitors.length > 10 ? 'Briefing.onlineBriefing.settings.competitor.limit' : 'Briefing.onlineBriefing.settings.competitor.add'"
                            [disabled]="competitors.length > 10"
                            [style]="buttonTypesEnum.icon"
                            tooltipPosition="left"
                            (click)="addCompetitor()"
                        >
                        </agpr-button>
                    </div>
                }
                <agpr-scroll-panel
                    #rightScrollPanel
                >
                    <div class="agpr-newOnlineBriefing-mainRight-content">
                        @if (selectedTemplate === onlineBriefingTemplateEnum.ONLINE_BRIEFING_TEMPLATE_DEFAULT
                            || selectedTemplate === onlineBriefingTemplateEnum.ONLINE_BRIEFING_TEMPLATE_QUARTERLY
                            || selectedTemplate === onlineBriefingTemplateEnum.ONLINE_BRIEFING_TEMPLATE_MONTHLY
                        ) {
                            <h2 class="agpr-newOnlineBriefing-main-content-heading">
                                <span>{{ 'Briefing.onlineBriefing.settings.coverageSource' | localize }}</span>
                                <span class="agpr-requiredAsterix"> * </span>
                            </h2>
                            <div #brandCardDataSourceRight>
                                <ng-container *ngTemplateOutlet="brandCardTemp.dataSourcePicker()"></ng-container>
                            </div>
                            <ng-container *ngTemplateOutlet="analysisFocusTemp"></ng-container>
                            <ng-container *ngTemplateOutlet="bannerStyle"></ng-container>
                        }

                        @if (selectedTemplate === onlineBriefingTemplateEnum.ONLINE_BRIEFING_TEMPLATE_COMPETITOR) {
                            @for(competitor of competitors; track i; let i = $index) {
                                @let id = competitor?.brand?.id;
                                <div class="agpr-newOnlineBriefing-competitorCard agpr-contextMenu-parent">
                                    <agpr-monitoring-brand-card
                                        [id]="'agpr_newOnlineBriefing_competitorCard_' + i"
                                        [hideBorder]="true"
                                        [toggleButtonLabel]="'Briefing.onlineBriefing.settings.competitor.toggle'"
                                        [showDataSourceField]="true"
                                        [dataSourceConfigs]="competitorCardDataSourceConfigs"
                                        [ngModel]="competitor"
                                        (ngModelChange)="onCompetitorCardChanged($event, i)"
                                    ></agpr-monitoring-brand-card>
                                    <div class="agpr-contextMenu right bottom">
                                        @if (!$first) {
                                            <agpr-button
                                                [id]="'agpr_newOnlineBriefing_competitorCard' + i + '_moveUp'"
                                                [style]="buttonTypesEnum.contextMenu"
                                                icon="fa-regular fa-arrow-up"
                                                tooltip="Common.brandIdentity.manageDialog.button.moveUp"
                                                tooltipPosition="top"
                                                (click)="moveUp(i)"
                                            ></agpr-button>
                                        }
                                        @if (!$last) {
                                            <agpr-button
                                                [id]="'agpr_newOnlineBriefing_competitorCard' + i + '_moveDown'"
                                                [style]="buttonTypesEnum.contextMenu"
                                                icon="fa-regular fa-arrow-down"
                                                tooltip="Common.brandIdentity.manageDialog.button.moveDown"
                                                tooltipPosition="top"
                                                (click)="moveDown(i)"
                                            ></agpr-button>
                                        }
                                        @if (competitors.length > 1) {
                                            <agpr-button
                                                [id]="'agpr_newOnlineBriefing_competitorCard' + i + '_deleteButton'"
                                                [style]="buttonTypesEnum.contextMenu"
                                                icon="fa-regular fa-duotone fa-square-xmark"
                                                tooltip="DataConnector.contextMenu.delete"
                                                tooltipPosition="top"
                                                (click)="deleteCompetitor(i)"
                                            ></agpr-button>
                                        }
                                    </div>
                                </div>
                                @if (id !== null && id !== undefined && duplicateBrandIds[id]) {
                                    <agpr-message [severity]="messageSeverityEnum.error">
                                        {{ 'Briefing.onlineBriefing.settings.competitor.duplicateBrand' | localize }}
                                    </agpr-message>
                                }
                            }
                        }
                    </div>
                </agpr-scroll-panel>
            </div>
        </div>
        @if (hasOpenAI) {
            <agpr-copilot-switch-banner
                [description]="'Briefing.onlineBriefing.template.openAiDescription' | localize"
                [(ngModel)]="enableCoPilot"
                (ngModelChange)="updateDataSourceConfigs()"
                [title]="'Briefing.onlineBriefing.template.switchBanner.title'"
            ></agpr-copilot-switch-banner>
        }
    </ng-template>

    @if (isChoosingTemplate && !hasAgent) {
        <agpr-agentic-upsell-banner
            class="agpr-newOnlineBriefing-agenticUpsell"
            id="newOnlineBriefing_agenticUpsell"
            heading="Common.agenticUpsell.create.heading"
            message="Common.agenticUpsell.create.message"
            learnMoreUrl="https://www.agilitypr.com/agility-agent/"
        ></agpr-agentic-upsell-banner>
    }

    <agpr-action-bar class="agpr-newOnlineBriefing-actionBar">
        <ng-template #left>
            <agpr-button
                (click)="cancel()"
                [style]="buttonTypesEnum.secondary"
                label="Core.button.cancel"
            ></agpr-button>
        </ng-template>
        <ng-template #right>
            @if (selectedTabIndex === newOnlineBriefingTabsEnum.naturalLanguage) {
                <agpr-button
                    [style]="buttonTypesEnum.primary"
                    label="Briefings.newBriefing.createFromPrompt"
                    (click)="createBriefingFromPromptWithContext()"
                    [disabled]="!naturalLanguagePrompt.trim() || aiIsGenerating"
                    [loading]="aiIsGenerating"
                ></agpr-button>
            } @else if (isChoosingTemplate) {
                @let isPastBriefingTab = selectedTabIndex === newOnlineBriefingTabsEnum.pastBriefings;
                @let isSavedTemplatesTab = selectedTabIndex === newOnlineBriefingTabsEnum.savedTemplates;
                <agpr-button
                    [style]="buttonTypesEnum.primary"
                    [label]="isPastBriefingTab ? 'Core.button.copy' : 'Briefings.createDialog.next'"
                    (click)="nextStep()"
                    [disabled]="(isPastBriefingTab && !selectedBriefing) || (isSavedTemplatesTab && !selectedCanvasTemplate)"
                ></agpr-button>
            } @else {
                <agpr-button
                    [style]="buttonTypesEnum.primary"
                    label="Briefings.createDialog.createNewBriefing"
                    (click)="createBriefing()"
                ></agpr-button>
            }
        </ng-template>
    </agpr-action-bar>
</section>

<ng-template #analysisFocusTemp>
    @if (enableCoPilot) {
        <div>
            <h2 class="agpr-newOnlineBriefing-main-content-heading">
                {{ 'Briefing.onlineBriefing.settings.prCoPilot' | localize }}
            </h2>
            <agpr-text-input
                [label]="'Briefing.onlineBriefing.settings.analysisFocus'"
                [placeholder]="'Briefing.onlineBriefing.settings.analysisFocus.placeholder'"
                [tooltip]="'Briefing.onlineBriefing.settings.analysisFocus.tooltip'"
                [maxLength]="analysisFocusMaxLength"
                [(ngModel)]="analysisFocus"
            ></agpr-text-input>
        </div>
    }
</ng-template>

<ng-template #mainBrandInfo let-showSourcePicker="showSourcePicker">
    <div class="agpr-newOnlineBriefing-competitor-card">
        <div
            class="agpr-newOnlineBriefing-competitor-card-summaryContainer"
            [@containerState]="{value: mainInfoExpanded ? 'collapsed' : 'expanded'}"
        >
            <div class="agpr-newOnlineBriefing-competitor-card-summary">
                <div
                    class="agpr-newOnlineBriefing-competitor-card-imagePlaceholder"
                    [style.background-color]="accentColor"
                >
                    <span>{{ avatarPlaceholderName }}</span>
                </div>
                <div class="agpr-newOnlineBriefing-competitor-card-summary-name">
                    @if (name) {
                        {{ name }}
                    } @else {
                        {{ 'Briefing.onlineBriefing.settings.competitor.brandName' | localize }}
                    }
                </div>
            </div>
            <div [hidden]="mainInfoExpanded">
                @if (hasNameError) {
                    <agpr-form-message>
                        {{ 'Briefing.onlineBriefing.settings.competitor.name.required' | localize }}
                    </agpr-form-message>
                }
                @if (showSourcePicker && !isDataSourceValid && showDataSourceErrors) {
                    <agpr-form-message>
                        {{ 'Briefing.onlineBriefing.settings.competitor.dataSource.error' | localize }}
                    </agpr-form-message>
                }
            </div>
        </div>
        <div
            class="agpr-newOnlineBriefing-competitor-card-contentContainer"
            [@containerState]="{value: mainInfoExpanded ? 'expanded' : 'collapsed'}"
        >
            <agpr-text-input
                [placeholder]="'Briefing.onlineBriefing.settings.competitor.name.placeholder' | localize"
                [label]="'Briefing.onlineBriefing.settings.competitor.name'"
                [required]="true"
                [(ngModel)]="name"
                [bottomMargin]="!hasNameError"
                (ngModelChange)="nameChanged()"
            ></agpr-text-input>
            @if (hasNameError) {
                <agpr-form-message>
                    {{ 'Briefing.onlineBriefing.settings.competitor.name.required' | localize }}
                </agpr-form-message>
            }
            @if (showSourcePicker) {
                <div>
                    <h2 class="agpr-newOnlineBriefing-main-content-heading">
                        {{ 'Briefing.onlineBriefing.settings.coverageSource' | localize }}<span class="agpr-requiredAsterix"> * </span>
                    </h2>
                    <div class="agpr-newOnlineBriefing-mainLeft-sourcePicker">
                        <agpr-monitoring-source-picker-with-facet-and-search-field
                            [id]="'agpr_newBriefing_quickTemplates_sourcePicker'"
                            [field]="sourceField"
                            [value]="dataSource"
                            [isGlobalDateRange]="true"
                            (changes)="sourceSelected($event)"
                            [showHiddenOption]="true"
                            [showErrors]="showDataSourceErrors"
                        ></agpr-monitoring-source-picker-with-facet-and-search-field>
                    </div>
                </div>
            }
            <div>
                <agpr-multi-content-library-panel
                    [field]="logoField"
                    (changes)="logo = $event"
                ></agpr-multi-content-library-panel>
            </div>
            <div class="agpr-newOnlineBriefing-mainRight-colorLabel">
                {{ 'Briefing.onlineBriefing.settings.competitor.brandingColour' | localize }}
            </div>
            <div class="agpr-newOnlineBriefing-mainRight-colorPicker">
                <agpr-color-picker-field
                    [doBorder]="true"
                    [(ngModel)]="accentColor"
                ></agpr-color-picker-field>
            </div>
        </div>
        <div class="agpr-newOnlineBriefing-competitor-card-toggleButton">
            <agpr-button
                class="agpr-newOnlineBriefing-toggleButton"
                [style]="buttonTypesEnum.link"
                ariaLabel="Briefing.onlineBriefing.settings.competitor.toggle"
                tooltip="Briefing.onlineBriefing.settings.competitor.toggle"
                tooltipPosition="left"
                [expanded]="mainInfoExpanded"
                (click)="toggleMainInfoDetails()"
            >
                <span
                    class="fa-solid agpr-newOnlineBriefing-competitor-card-expandIcon"
                    aria-hidden="true"
                    [ngClass]="{
                        'fa-angle-down': mainInfoExpanded,
                        'fa-angle-up': !mainInfoExpanded
                    }"
                ></span>
            </agpr-button>
        </div>
    </div>
</ng-template>

<ng-template #bannerStyle>
    <div>
        <h2 id="banner_label" class="agpr-newOnlineBriefing-main-content-heading">{{ 'Briefing.onlineBriefing.settings.bannerStyle' | localize }}</h2>
        <div class="agpr-newOnlineBriefing-bannerStyleContainer" role="radiogroup" aria-labelledby="banner_label">
            <button
                class="agpr-newOnlineBriefing-bannerStyleButton"
                [ngClass]="{'agpr-newOnlineBriefing-bannerStyleButton--focused': selectedBannerStyle === onlineBriefingBannerStyle.SIMPLE}"
                (click)="onBannerStyleSelect(onlineBriefingBannerStyle.SIMPLE)"
                role="radio"
                [attr.aria-checked]="selectedBannerStyle === onlineBriefingBannerStyle.SIMPLE"
                tabindex="0"
                aria-labelledby="simple_label"
            >
                <img
                    class="agpr-newOnlineBriefing-bannerStyleImage"
                    [src]="appBaseHref + 'assets/images/online_briefing_frame_style_simple.svg'"
                    alt=""
                />
                <span id="simple_label" class="agpr-newOnlineBriefing-bannerStyleLabel">
                    {{ 'Briefing.onlineBriefing.settings.bannerStyle.simple' | localize }}
                </span>
            </button>
            <button
                class="agpr-newOnlineBriefing-bannerStyleButton"
                [ngClass]="{'agpr-newOnlineBriefing-bannerStyleButton--focused': selectedBannerStyle === onlineBriefingBannerStyle.IMAGE_GRID}"
                (click)="onBannerStyleSelect(onlineBriefingBannerStyle.IMAGE_GRID)"
                role="radio"
                [attr.aria-checked]="selectedBannerStyle === onlineBriefingBannerStyle.IMAGE_GRID"
                tabindex="0"
                aria-labelledby="imageGrid_label"
            >
                <img
                    class="agpr-newOnlineBriefing-bannerStyleImage"
                    [src]="appBaseHref + 'assets/images/online_briefing_frame_style_image_grid.svg'"
                    alt=""
                />
                <span id="imageGrid_label" class="agpr-newOnlineBriefing-bannerStyleLabel">
                    {{ 'Briefing.onlineBriefing.settings.bannerStyle.imageGrid' | localize }}
                </span>
            </button>
        </div>
    </div>
</ng-template>
